module.exports = __webpack_public_path__ + "img/get-free-insurance-quote-page-top.49f417ab.svg";